import PropTypes from "prop-types";
import { Outlet } from "react-router-dom";
import TopTabBar from "../TopTabBar";
import "./SectionLayout.scss";

const SectionLayout = ({ companyName, title, subtitle, tabs, tabActions, heroStats, heroExtra, showBanner = true }) => {
  return (
    <div className="section-layout">
      {/* Hero Banner */}
      {showBanner && (
        <div className="section-hero section-hero--compact">
          <div className="section-hero__overlay" />
          <svg className="section-hero__particles" aria-hidden="true">
            {Array.from({ length: 18 }).map((_, i) => (
              <circle
                key={i}
                className="section-hero__particle"
                cx={`${6 + ((i * 31) % 90)}%`}
                cy={`${8 + ((i * 17) % 85)}%`}
                r={1 + (i % 3)}
                style={{ animationDelay: `${(i * 0.4) % 6}s`, animationDuration: `${4 + (i % 4)}s` }}
              />
            ))}
          </svg>
          <div className="section-hero__content">
            <div className="section-hero__text">
              {companyName && <span className="section-hero__company">{companyName}</span>}
              <h1 className="section-hero__title">{title}</h1>
              {subtitle && <p className="section-hero__subtitle">{subtitle}</p>}
            </div>
            {heroStats && <div className="section-hero__live-stats">{heroStats}</div>}
            {heroExtra && <div className="section-hero__extra">{heroExtra}</div>}
          </div>
        </div>
      )}

      {/* Top Tab Bar */}
      <TopTabBar tabs={tabs} actions={tabActions} />

      {/* Page Content */}
      <div className="section-layout__content">
        <Outlet />
      </div>
    </div>
  );
};

SectionLayout.propTypes = {
  companyName: PropTypes.string,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  tabs: PropTypes.array.isRequired,
  tabActions: PropTypes.node,
  heroStats: PropTypes.node,
  heroExtra: PropTypes.node,
  showBanner: PropTypes.bool,
};

export default SectionLayout;
